import CenterFooterContent from '../CenterFooterContent';
import LeftFooterContent from '../LeftFooterContent';
import RightFooterContent from '../RightFooterContent';
import StaticFooter from './StaticFooter';
import BreakreminderLogo from '../../../assets/logo_breakreminder_light.svg'
import styled from 'styled-components/macro'

const DarkText = styled.div`
  color: rgb(${p => p.theme.color.text.primary});
  text-transform: uppercase;
  letter-spacing: 0.2em;
`

export default () => (
  <StaticFooter>
    <LeftFooterContent />
    <CenterFooterContent>
      <br />
      Copyright © 2018 - 2022 Berlin<br /><br />
      Website-Design von Paul Lange<br />
      Technische Umsetzung durch Oscar Ruckdeschel & Paul Lange<br />
      Header Hintergrund: 'Tree Bark' <a href='https://www.toptal.com/designers/subtlepatterns/tree-bark/' rel='noopener noreferrer' target='_blank'>CC BY-SA 3.0 - Subtle Patterns</a><br /><br />
      <a href='https://register.dpma.de/DPMAregister/marke/register/3020110030960/DE' rel='noopener noreferrer' target='_blank'>
        <img src={ BreakreminderLogo } style={{ fill: 'white' }} width='200px' alt='Logo breakreminder'/>
      </a>
      <DarkText>Ist eine eingetragene Wort-Bildmarke</DarkText>
    </CenterFooterContent>
    <RightFooterContent />
  </StaticFooter>
);
